export default __webpack_public_path__ + "static/media/1659.e9a47c20.png";